import { useMemo } from 'react';

import { ProductListSkeleton } from 'ui/components';
import { catalog } from 'core';

import ProductList from './components';
import type { ProductsWidgetProps } from './Products.d';
import { AVAILABLE_OPTION } from 'core/domains/catalog.d';

const ProductCatalogWidget = ({ config, widgetKey }: ProductsWidgetProps) => {
  const offset = config.pagination ? config.pageSize : config.limit;

  const { category, department, query, geraCategory } = catalog.hooks.useLocationQueryOptions();

  const queryOptions = useMemo(
    () => ({
      itemsPerPage: Number(offset),
      department,
      category,
      geraCategory,
      query,
      availability: AVAILABLE_OPTION.first,
    }),
    [category, department, geraCategory, offset, query],
  );

  const { data, isLoading } = catalog.hooks.useCatalog(queryOptions);

  if (isLoading) {
    return <ProductListSkeleton itemsPerRowDesktop={4} />;
  }

  return <ProductList data={data} widgetKey={widgetKey} />;
};

export default ProductCatalogWidget;
